module.exports = __webpack_public_path__ + "img/data-structure.83af9680.png";